const checkServicePaymentFields = ({merchantAccount, uaPayMerchantId, tzzApiKey, lqpPublic}) => {
    return !!(merchantAccount || uaPayMerchantId || tzzApiKey || lqpPublic);
};

export default checkServicePaymentFields;